'use strict';

angular.module('TurneroApp').component('coTurnodetalles', {
	bindings: {
		idTurno: '<',
		ctrlPadre: '=',
		turnoDetalles: '=',
		boolToShow: '='
	},
	controller: [
		 '$anchorScroll',
		 '$scope',
		 'turnosService',
		 '$rootScope',
		 'utilsService',
		 function (
		 $anchorScroll,
		 $scope,
		 turnosService,
		 $rootScope,
		 utilsService
) {
		 	var ctrl = this;
		 	ctrl.detalleTurnoInfo = {};

		 	ctrl.$onChanges = function () {
		 		if (ctrl.idTurno && ctrl.turnoDetalles) {
		 			ctrl.boolToShow = false;
		 			utilsService.swalTitle('Obteniendo detalles del turno', 'info')
		 			// you could inspect the data to see if what you care about changed, or just update your own scope
		 			turnosService.Get_Detalle({ 'id_turno': ctrl.idTurno }).$promise.then(function (data) {
		 				ctrl.detalleTurnoInfo = data;
		 				swal.close();
		 			}).catch(function (error) {
		 				ctrl.cerrarDetalle()
		 				utilsService.errores(error);
		 			});
		 		}
		 	}

		 	ctrl.cerrarDetalle = function () {
		 		//MOSTRAR DETALLE Y OCULTAR LA GRILLA DE CONSULTA
		 		ctrl.turnoDetalles = false;
		 		ctrl.ctrlPadre.turnoDetalleReagendado = false;
		 		if (ctrl.boolToShow == false) ctrl.boolToShow = true;
		 	};
		 }
	],
	template: require('./turnoDetalle.html')
});



// WEBPACK FOOTER //
// ./app/components/turnos/turnoDetalleComponent.js